export default "<p>\n  footer-component works!\n</p>\n";